import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

import Link from '@/components/link/link'
import { resolvePctLinkUrl } from '@/internal/utils/resolve-pctlink-url'

import * as style from './footer.module.scss'

const Footer = () => {
  const data: {
    footer: {
      nodes: Queries.DatoCmsPctNavigation[]
    }
  } = useStaticQuery(graphql`
    {
      footer: allDatoCmsPctNavigation(
        filter: { codeId: { eq: "insurance-report-footer-navigation" } }
      ) {
        nodes {
          navigationItems {
            ...PctNavigationItems
          }
        }
      }
    }
  `)

  const footerNavigationItems = data?.footer?.nodes?.[0]?.navigationItems ?? []

  return (
    <section className={`${style.section} bg-base-000`}>
      <div className="container">
        <div className="row">
          {footerNavigationItems?.length > 0 &&
            footerNavigationItems?.map((el, index) => (
              <React.Fragment key={index}>
                <div className="col-lg-4 col-12" key={el?.id}>
                  <h3 className={`${style.title} text-base-1000 b200 p-0`}>
                    {el?.externalName}
                  </h3>
                </div>
                <div className="col-lg-8 col-12">
                  <ul className={`${style.list} m-0 p-0`}>
                    {el?.navigationLinks?.length > 0 &&
                      el?.navigationLinks?.map((item) => (
                        <li key={item?.id}>
                          <Link
                            className={`${style.item} text-base-1000 b200`}
                            to={resolvePctLinkUrl(item)}
                            openInNewWindow={item?.openInNewWindow}
                          >
                            {item?.externalName}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              </React.Fragment>
            ))}
        </div>
      </div>
    </section>
  )
}

export default Footer
